import './prohibited-goods.css';
import RestrictionsIcons from "../../../../components/restrictions-icons/restrictions-icons";
import iconSharkFin from "../../../../assets/imgs/prepare-shipment/restrictions/icon-shark-fin.svg";
import iconInfectedAnimals from "../../../../assets/imgs/prepare-shipment/restrictions/icon-infected-animals.svg";
import iconPrimatesFerrets from "../../../../assets/imgs/prepare-shipment/restrictions/icon-primates-ferrets.svg";
import iconDeadAnimals from "../../../../assets/imgs/prepare-shipment/restrictions/icon-dead-animals.svg";
import iconHuntingTrophies from "../../../../assets/imgs/prepare-shipment/restrictions/icon-hunting-trophies.svg";
import iconPregnantAnimals from "../../../../assets/imgs/prepare-shipment/restrictions/icon-pregnant-animals.svg";
import iconPuppyFootprints from "../../../../assets/imgs/prepare-shipment/restrictions/icon-puppy-footprints.svg";
import iconPenetratingOdors from "../../../../assets/imgs/prepare-shipment/restrictions/icon-penetrating-odors.svg";
import iconPiracy from "../../../../assets/imgs/prepare-shipment/restrictions/icon-piracy.svg";
import iconDrugs from "../../../../assets/imgs/prepare-shipment/restrictions/icon-drugs.svg";
import iconFirearms from "../../../../assets/imgs/prepare-shipment/restrictions/icon-firearms.svg";
import iconLithiumBatterie from "../../../../assets/imgs/prepare-shipment/restrictions/icon-lithium-batterie.svg";
import iconRadioactive from "../../../../assets/imgs/prepare-shipment/restrictions/icon-radioactive.svg";
import iconSelfBalancing from "../../../../assets/imgs/prepare-shipment/restrictions/icon-self-balancing.svg";
import iconBlood from "../../../../assets/imgs/prepare-shipment/restrictions/icon-blood.svg";
import catImg from "../../../../assets/imgs/prepare-shipment/restrictions/cat.png";
import dogImg from "../../../../assets/imgs/prepare-shipment/restrictions/dog.png";
import alertIcon from "../../../../assets/imgs/prepare-shipment/restrictions/icon-alert.svg";
import chemicalPrecursorsImg from "../../../../assets/imgs/prepare-shipment/restrictions/chemical_precursors.png";
import essentialChemicalsImg from "../../../../assets/imgs/prepare-shipment/restrictions/essential_chemicals.png";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import HazardousGoods from '../hazardous-goods/hazardous-goods';

function ProhibitedGoods() {
  const [tRestrictions] = useTranslation("restrictions");
  const idComponent = "35b4cb80-b8c1-41b9-b935-39b258fa2676";
  const [dataInformation, setDataInformation] = useState(() => {
    const newData = {};

    for (let i = 1; i <= 83; i++) {
      newData[`text-${i}`] = "";
    }

    newData["titulo"] = "";

    return {
      "Mercancías prohibidas para su transporte": newData,
    };
  });
  
  const getTexts = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponent}`);

      if (currentLng === "es") {
        setDataInformation(
          response.data.textWeb.text_es[
            "Mercancías prohibidas para su transporte"
          ]
        );
      } else {
        setDataInformation(
          response.data.textWeb.text_us[
            "Mercancías prohibidas para su transporte"
          ]
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTexts();
  }, []);

  const addBoldText = (text) => {
    const keyword = "Aeroméxico Cargo:";
    if (!text.includes(keyword)) return text;
    const parts = text.split(keyword);
    return parts.map((part, index) => (
      <span key={index}>
        {part}
        {index < parts.length - 1 && <strong>{keyword}</strong>}
      </span>
    ));
  }

  return (
    <>
      <div className="res-prohibited-container">
        <h3>
          {dataInformation["titulo"] ??
            tRestrictions("prohibited-goods.prohibited-goods")}
        </h3>
        <div className='res-description'>
          {addBoldText(dataInformation["description"] ?? "")}
        </div>

        <div className='items-content'>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconSharkFin}
              iconAlt="Shark Fin Icon"
              height="40px"
              info={
                dataInformation["mppt-text-1"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconInfectedAnimals}
              iconAlt="Infected Animal Icon"
              height="40px"
              info={
                dataInformation["mppt-text-2"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconPrimatesFerrets}
              iconAlt="Primates Ferrets Icon"
              height="40px"
              info={
                dataInformation["mppt-text-3"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconDeadAnimals}
              iconAlt="Dead Animals Icon"
              height="40px"
              info={
                dataInformation["mppt-text-4"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconHuntingTrophies}
              iconAlt="Hunting Trophies Icon"
              height="40px"
              info={
                dataInformation["mppt-text-5"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconPregnantAnimals}
              iconAlt="Pregnant Animals Icon"
              height="40px"
              info={
                dataInformation["mppt-text-6"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconPuppyFootprints}
              iconAlt="Puppy Footprint Icon"
              height="40px"
              info={
                dataInformation["mppt-text-7"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconPenetratingOdors}
              iconAlt="Penetrating Odors Icon"
              height="40px"
              info={
                dataInformation["mppt-text-8"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconPiracy}
              iconAlt="Piracy Icon"
              height="40px"
              info={
                dataInformation["mppt-text-9"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconDrugs}
              iconAlt="Drugs Icon"
              height="40px"
              info={
                dataInformation["mppt-text-10"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconFirearms}
              iconAlt="Firearms Icon"
              height="40px"
              info={
                dataInformation["mppt-text-11"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconLithiumBatterie}
              iconAlt="Lithium Batterie Icon"
              height="40px"
              info={
                dataInformation["mppt-text-12"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconRadioactive}
              iconAlt="Radioactive Icon"
              height="40px"
              info={
                dataInformation["mppt-text-13"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconSelfBalancing}
              iconAlt="Self Balancing Icon"
              height="40px"
              info={
                dataInformation["mppt-text-14"] ?? ""
              }
              fontSize="12px"
            />
          </div>
          <div className='item'>
            <RestrictionsIcons
              iconSrc={iconBlood}
              iconAlt="Blood Icon"
              height="40px"
              info={
                dataInformation["mppt-text-15"] ?? ""
              }
              fontSize="12px"
            />
          </div>
        </div>

        <div className='warning-content'>
          <div className='icon-content'>
            <img className="i-warning" src={alertIcon} alt="Alert Icon" />
            <h6>{dataInformation["restrictions-live-animals-title"] ?? ""}</h6>
          </div>

          <p>
            {dataInformation["restrictions-live-animals-text"] ?? ""}
          </p>
        </div>

        <div className='cat-dog-content'>
          <div className='img-content'>
            <img
              src={dogImg}
              alt="Brachycephalic dog"
            />
          </div>

          <div className='brachycephalic-content'>
            <div className='brachycephalic-item'>
              <h5>{dataInformation["brachycephalic-dogs-title"] ?? ""}</h5>
              <ul className='text-content'>
                {dataInformation["brachycephalic-dogs"] && dataInformation["brachycephalic-dogs"].split(",").map((item, index) => (
                  <li key={index}>{item.trim()}</li>
                ))}
              </ul>
            </div>

            <div className='brachycephalic-item'>
              <h5>{dataInformation["brachycephalic-cats-title"] ?? ""}</h5>
              <ul className='text-content'>
                {dataInformation["brachycephalic-cats"] && dataInformation["brachycephalic-cats"].split(",").map((item, index) => (
                  <li key={index}>{item.trim()}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <HazardousGoods />

        <div className='chemicals-container'>
          <div className='image'>
            <img src={chemicalPrecursorsImg} alt='chemicals' />
          </div>

          <div className='info-container'>
            <div className='precursors'>
              <p className='title'>{dataInformation["chemical-precursors-title"] ?? ""}</p>
              <ul>
                {dataInformation["chemical-precursors-text"] && dataInformation["chemical-precursors-text"].split(",").map((item, index) => (
                  <li key={index}>{item.trim()}</li>
                ))}
              </ul>
            </div>
            <div className='products'>
              <p className='title'>{dataInformation["chemical-products-title"] ?? ""}</p>
              <ul>
                {dataInformation["chemical-products-text"] && dataInformation["chemical-products-text"].split(",").map((item, index) => (
                  <li key={index}>{item.trim()}</li>
                ))}
              </ul>
            </div>

          </div>
        </div>

      </div>
    </>
  );
}

export default ProhibitedGoods;
